import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    rootContainer: {
      display: "flex",
      flexDirection: "column",
    },
    cardContainer: {
      "& > * + *": {
        borderTop: "1px solid #EAECF0",
        paddingTop: "24px",
      },
      inputwrapper: {
        width: "100% !important",
        [theme.breakpoints.down("500")]: {
          "& label": {
            minWidth: "auto",
          },
        },
      },
      //   maxWidth: "426px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      marginTop: "24px",
      width: "100%",
      padding: "24px 32px",
      minHeight: "100vh",
      [theme.breakpoints.down("1420")]: {
        width: "100%",
        maxWidth: "initial",
        minHeight: "initial",
      },
      [theme.breakpoints.down("500")]: {
        padding: "16px",
      },
    },
    wrapperTabsRoot: {
      maxWidth: "200px !important",
      width: "max-content",
      padding: "0px !important",

      "& .MuiTabs-scroller": {
        background: "transparent !important",
        width: "100% !important",

        "& .MuiTabs-flexContainer": {
          border: "none !important",
        },

        "& .MuiButtonBase-root": {
          marginBottom: "4px !important",
          fontSize: "16px !important",
          fontWeight: "600 !important",
          lineHeight: "24px !important",
          padding: "10px 14px !important",
          width: "100% !important",
          color: `${theme.palette?.text?.text_quarterary} !important`,

          "& span": {
            alignItems: "flex-start !important",
          },

          "&.Mui-selected": {
            border: "none !important",
            background: "transparent !important",
            borderInlineStart: `2px solid ${theme.palette?.foreground?.brandPrimary} !important`,
            borderRadius: "0px !important",
            color: `${theme.palette?.text?.brand_secondary} !important`,
          },
        },
      },
    },
    contentWrapper: {
      display: "flex",
      gap: "32px",
      marginTop: "32px",
    },
    headingContainer: {
      display: "flex",
    },
    label: {
      maxWidth: "280px",
      width: "100%",
      fontWeight: "600",
      fontSize: "14px",
    },
    fieldWrapper: {
      display: "flex",
      gap: "32px",
    },
    actionContainer: {
      display: "flex",
      gap: "12px",
    },
    subTitleWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
    rangeSlider: {
      maxWidth: "515px",
    },
    formContent: {
      width: "100%",
    },
    isBulkContainer: {
      "& div": {
        margin: "0",
      },
    },
    checkboxWrapper: {
      display: "flex",
      gap: "12px",
    },
    switchWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    mainHeading: {
      display: "flex",
      gap: "16px",
      alignItems: "baseline",
    },
    subtitle: {
      display: "flex",
      alignItems: "baseline",
      gap: "8px",
    },
    errorMessage: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 400,
      color: theme.palette.text.error_primary,
      paddingTop: "12px",
    },
    checkboxLabel: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "500",
    },
  };
});
